"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const common_1 = require("./common");
const moment_1 = __importDefault(require("moment"));
function orderOptions(arr, type, direction) {
    if (direction === 'manual') {
        console.warn('No manual direction allowed');
        direction = 'asc';
    }
    return (0, lodash_1.orderBy)(arr, option => {
        switch (type) {
            case 'date':
                return (0, moment_1.default)(option).valueOf();
            default:
                return option;
        }
    }, direction);
}
function groupAndOrderBy(arr, type, getOption, direction, maxGroups = null) {
    if (!maxGroups || maxGroups >= countUniqueOptions(arr, getOption)) {
        return groupAndOrderBy_groupPerOption(arr, type, getOption, direction);
    }
    return groupAndOrderBy_makeRanges(arr, type, getOption, direction, maxGroups);
}
exports.default = groupAndOrderBy;
function countUniqueOptions(arr, getOption) {
    const arrWithOptions = arr.map(item => {
        let option = getOption(item);
        if (option === undefined)
            option = null;
        return { item, option };
    });
    const uniqueOptions = arrWithOptions
        .map(a => a.option)
        .filter(common_1.filterUnique);
    return uniqueOptions.length;
}
function groupAndOrderBy_groupPerOption(arr, type, getOption, direction) {
    const arrWithOptions = arr.map(item => {
        let option = getOption(item);
        if (option === undefined)
            option = null;
        return { item, option };
    });
    const uniqueOptions = arrWithOptions
        .map(a => a.option)
        .filter(common_1.filterUnique);
    const orderedUniqueOptions = orderOptions(uniqueOptions, type, direction);
    const groups = orderedUniqueOptions.map(option => {
        const items = arrWithOptions
            .filter(it => it.option === option)
            .map(it => it.item);
        return {
            items,
            type: 'single',
            option,
        };
    });
    return groups;
}
function groupAndOrderBy_makeRanges(arr, type, getOption, direction, numGroups) {
    let arrWithOptions = arr.map(item => {
        let option = getOption(item);
        if (option === undefined)
            option = null;
        return { item, option };
    });
    let uniqueOptions = arrWithOptions
        .map(a => a.option)
        .filter(common_1.filterUnique);
    const nullItems = arrWithOptions
        .filter(a => a.option === null)
        .map(a => a.item);
    // Remove the null value here
    uniqueOptions = uniqueOptions.filter(a => a !== null);
    arrWithOptions = arrWithOptions.filter(a => a.option !== null);
    const ranges = createRanges(uniqueOptions, type, numGroups);
    let groups = ranges.map((range, i) => {
        const isLast = i === ranges.length - 1;
        const items = arrWithOptions
            .filter(it => inRange(type, it.option, range, isLast))
            .map(it => it.item);
        // Remove the chosen items
        arrWithOptions = arrWithOptions.filter(it => !inRange(type, it.option, range, isLast));
        if (!items.length) {
            console.warn("Empty group for range", range);
        }
        return {
            items,
            type: 'range',
            option: range.a,
            optionB: range.b,
        };
    });
    if (arrWithOptions.length) {
        console.error("Options not selected", arrWithOptions);
    }
    // Just in case
    groups = groups.filter(g => g.items.length);
    if (direction === 'desc') {
        groups = groups.reverse();
    }
    // Add the num items
    if (nullItems.length) {
        groups.push({
            items: nullItems,
            type: 'single',
            option: null,
        });
    }
    return groups;
}
function createRanges(options, type, numGroups) {
    switch (type) {
        case 'date':
            return createRangesDate(options, numGroups);
        case 'number':
            return createRangesNumber(options, numGroups);
        default:
            throw 'No supported type';
    }
}
function round(x, n = 0) {
    const z = Math.pow(10, n);
    return Math.round(x * z) / z;
}
function createRangesNumber(options, numGroups) {
    let is_int = true;
    options.forEach(opt => {
        if (!Number.isInteger(opt))
            is_int = false;
    });
    const min = Math.min(...options);
    const max = Math.max(...options);
    const step = (max - min) / numGroups;
    const ranges = [];
    for (let i = 0; i < numGroups; i++) {
        ranges.push({
            a: round(min + step * i, is_int ? 0 : 2),
            b: round(min + step * (i + 1), is_int ? 0 : 2),
        });
    }
    return ranges;
}
function createRangesDate(options, numGroups) {
    const options2 = options.map(o => (0, moment_1.default)(o));
    const min = moment_1.default.min(options2).clone();
    const max = moment_1.default.max(options2).clone();
    const step = max.diff(min, 'days', true) / numGroups;
    const ranges = [];
    for (let i = 0; i < numGroups; i++) {
        ranges.push({
            a: min.clone().add(step * i, 'days'),
            b: min.clone().add(step * (i + 1), 'days'),
        });
    }
    return ranges;
}
function inRange(type, option, range, isLast) {
    // Should not be possible now. These values are filtered
    //f(option === null) return false;
    // The last range takes the rest
    if (isLast)
        return true;
    switch (type) {
        case 'number':
            return option < range.b;
        case 'date':
            return (0, moment_1.default)(option).isBefore(range.b);
        default:
            throw 'No supported type';
    }
}
